<template>
<div></div>
</template>

<script>
export default {
    data() {
        return {}
    },
    beforeRouteEnter (to, from, next) {
     
        // console.log(from,'22')
        let url=from.path
       next( vm => vm.$router.push({
            path: url
        }));
    // next(vm => vm.$router.replace(from.path))
  },
    // created() {
    //     const url = this.$route.query;
    //     // console.log(url)
    //     let str = '';
    //     for (let i in url) {
    //         str += url[i];
    //     }
    //     // console.log(str, '99991')
    //     // console.log(url.key)
    //     // const path = this.$route.query;
    //     // console.log(path)
    //     this.$router.push({
    //         path: str
    //     });
    //     // console.log(path, '1')
    // }
}
</script>

<style>
  </style>
